import title from './animations/title';
import text from './animations/text';
import pictureIn from './animations/pictureIn';
import heroPicture from './animations/heroPicture';
import heroTitle from './animations/heroTitle';
import tableItem from './animations/tableItem';
import parallax from './animations/parallax';

const animations = new Map();

animations.set('title', title);
animations.set('text', text);
animations.set('picture', pictureIn);
animations.set('sponsorLogo', pictureIn);
animations.set('heropicture', heroPicture);
animations.set('herotitle', heroTitle);
animations.set('herotext', title);
animations.set('tableitem', tableItem);
animations.set('parallax', parallax);

export default animations;
